<div
  class="relative p-[10px] border-2 border-solid border-transparent transition-border duration-300 ease-in-out hover:!border-2 hover:!border-solid hover:!border-primary w-[100%] cursor-pointer"
  [id]="'pagemodule' + content.id"
  [ngStyle]="{
    backgroundColor: styles.colors['other']['background'],
  }"
  [ngClass]="{
    '!border-2 !border-solid !border-primary': isSelectedModule,
  }">
  <div>
    <div
      class="text-center font-bold mb-5"
      [attr.style]="buildStyle('text', items[0].styles?.text)">
      {{ filter(items, 'type', 'text')[0]?.value.text }}
    </div>

    <div class="max-w-full overflow-x-auto scrollbar-hide">
      <div class="whitespace-nowrap justify-center inline-flex gap-4 items-center flex-wrap">
        @for (attr of filter(items, 'type', 'attribute'); track attr) {
          <div class="rounded-md p-2" [attr.style]="buildStyle('attribute', attr.styles?.text)">
            {{attr?.value?.text}}
          </div>
        }
      </div>
    </div>
  </div>
</div>
